const TipoCadastroMedicoTerceiroOptions = [
  { id: 20, text: "Médico Terceiro", value:"MedicoTerceiro" },
  { id: 19, text: "Médico Anestesista", value:"MedicoAnestesista" }
];

export { TipoCadastroMedicoTerceiroOptions};
